import type { ja } from '.'

// キーと値の間に改行が入ると翻訳システムと連携できなくなるため、prettier-ignoreしている
// prettier-ignore
export const locale = {
  'smarthr-ui/common/language': '繁體中文',
  'smarthr-ui/ActionDialog/closeButtonLabel': '取消',
  'smarthr-ui/AppHeader/school': 'SmartHR學習平台',
  'smarthr-ui/AppHeader/help': '幫助',
  'smarthr-ui/AppHeader/userSettings': '個人設定',
  'smarthr-ui/AppHeader/releaseNotes': '版本更新說明',
  'smarthr-ui/AppHeader/releaseNotesLoadError': '讀取版本更新說明失敗。\n請稍等片刻後再試。',
  'smarthr-ui/AppHeader/seeAllReleaseNotes': '查看所有版本更新說明',
  'smarthr-ui/AppHeader/DesktopHeader/appLauncherLabel': '功能',
  'smarthr-ui/AppHeader/MobileHeader/account': '帳號',
  'smarthr-ui/AppHeader/MobileHeader/openMenu': '打開選單',
  'smarthr-ui/AppHeader/MobileHeader/closeMenu': '關閉選單',
  'smarthr-ui/AppHeader/MobileHeader/allAppButton': '所有功能',
  'smarthr-ui/AppHeader/MobileHeader/managementMenu': '管理選單',
  'smarthr-ui/AppHeader/MobileHeader/latestReleaseNotes': '最新版本更新說明',
  'smarthr-ui/AppHeader/MobileHeader/back': '返回',
  'smarthr-ui/AppHeader/MobileHeader/openMenuAccordion': '展開',
  'smarthr-ui/AppHeader/MobileHeader/closeMenuAccordion': '關閉',
  'smarthr-ui/AppHeader/Launcher/searchInputTitle': '請輸入功能名稱。',
  'smarthr-ui/AppHeader/Launcher/favoriteModeText': '常用功能',
  'smarthr-ui/AppHeader/Launcher/allModeText': '所有功能',
  'smarthr-ui/AppHeader/Launcher/listText': '功能列表',
  'smarthr-ui/AppHeader/Launcher/helpText': '關於常用功能',
  'smarthr-ui/AppHeader/Launcher/searchResultText': '搜尋結果',
  'smarthr-ui/AppHeader/Launcher/emptyText': '找不到符合條件的功能。',
  'smarthr-ui/AppHeader/Launcher/sortDropdownLabel': '顯示排序',
  'smarthr-ui/AppHeader/Launcher/sortDropdownSelected': '選擇中',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderDefault': '預設',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderNameAsc': '以功能名稱遞增',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderNameDesc': '以功能名稱遞減',
  'smarthr-ui/AppLauncher/showAllText': '查看全部',
  'smarthr-ui/AppLauncher/triggerLabel': '功能',
  'smarthr-ui/Browser/notFoundDescription': '請嘗試其他條件。',
  'smarthr-ui/Browser/notFoundTitle': '沒有符合條件的項目。',
  'smarthr-ui/Button/loading': '處理中',
  'smarthr-ui/Calendar/currentYear': '目前年份',
  'smarthr-ui/Calendar/nextMonth': '下個月',
  'smarthr-ui/Calendar/previousMonth': '上個月',
  'smarthr-ui/Calendar/selectYear': '選擇年份',
  'smarthr-ui/Combobox/addItemButtonLabel': '新增「{name}」',
  'smarthr-ui/Combobox/loadingText': '處理中',
  'smarthr-ui/Combobox/noResultsText': '沒有符合條件的選項。',
  'smarthr-ui/DropdownMenuButton/triggerActive': '關閉選項',
  'smarthr-ui/DropdownMenuButton/triggerInactive': '展開選項',
  'smarthr-ui/DropZone/selectButtonLabel': '選擇檔案',
  'smarthr-ui/FileViewer/rotateAlt': '左轉',
  'smarthr-ui/FileViewer/scaleDownAlt': '縮小',
  'smarthr-ui/FileViewer/scaleRateLabel': '縮放比例',
  'smarthr-ui/FileViewer/scaleUpAlt': '放大',
  'smarthr-ui/FileViewer/unsupportedFileText': '不支援的檔案格式。',
  'smarthr-ui/FilterDropdown/applyText': '套用',
  'smarthr-ui/FilterDropdown/cancelText': '取消',
  'smarthr-ui/FilterDropdown/resetText': '清除篩選條件',
  'smarthr-ui/FilterDropdown/status': '已套用',
  'smarthr-ui/FilterDropdown/triggerText': '篩選',
  'smarthr-ui/FormDialog/closeButtonLabel': '取消',
  'smarthr-ui/InformationPanel/closeButtonLabel': '關閉',
  'smarthr-ui/InformationPanel/openButtonLabel': '展開',
  'smarthr-ui/InputFile/destroy': '刪除',
  'smarthr-ui/LanguageSwitcher/checkIconAlt': '已選擇',
  'smarthr-ui/Loader/alt': '處理中',
  'smarthr-ui/MessageDialog/closeButtonLabel': '關閉',
  'smarthr-ui/ModelessDialog/closeButtonIconAlt': '關閉',
  'smarthr-ui/ModelessDialog/dialogHandlerAriaLabel': '對話框位置',
  'smarthr-ui/ModelessDialog/dialogHandlerAriaRoleDescription': '可拖曳',
  'smarthr-ui/ModelessDialog/dialogHandlerDescription': '可以按箭頭鍵上下左右移動',
  'smarthr-ui/ModelessDialog/dialogHandlerLiveRegionText': '距離上方 {top} px，距離左側 {left} px',
  'smarthr-ui/MultiCombobox/destroyButtonIconAltSuffix': '：刪除',
  'smarthr-ui/MultiCombobox/selectedListAriaLabel': '已選項目',
  'smarthr-ui/NotificationBar/closeButtonIconAlt': '關閉',
  'smarthr-ui/Pagination/controllerItemButtonFirstLabel': '移至最前頁',
  'smarthr-ui/Pagination/controllerItemButtonLastLabel': '移至最後頁',
  'smarthr-ui/Pagination/controllerItemButtonNextLabel': '下一步',
  'smarthr-ui/Pagination/controllerItemButtonPreviousLabel': '上一步',
  'smarthr-ui/Pagination/itemButtonLabel': '第 {page} 頁',
  'smarthr-ui/Pagination/navigationLabel': '分頁',
  'smarthr-ui/RequiredLabel/text': '必填',
  'smarthr-ui/SearchInput/iconAlt': '搜尋',
  'smarthr-ui/SideMenu/navigationLabel': '側邊選單',
  'smarthr-ui/SingleCombobox/destroyButtonIconAlt': '清除',
  'smarthr-ui/SortDropdown/applyText': '套用',
  'smarthr-ui/SortDropdown/ascLabel': '遞增',
  'smarthr-ui/SortDropdown/cancelText': '取消',
  'smarthr-ui/SortDropdown/descLabel': '遞減',
  'smarthr-ui/SortDropdown/sortFieldLabel': '排序項目',
  'smarthr-ui/SortDropdown/sortOrderLegend': '排序方式',
  'smarthr-ui/StepFormDialog/backButtonLabel': '返回',
  'smarthr-ui/StepFormDialog/closeButtonLabel': '取消',
  'smarthr-ui/StepFormDialog/nextButtonLabel': '下一步',
  'smarthr-ui/StepStatusIcon/closedAlt': '中斷',
  'smarthr-ui/StepStatusIcon/completedAlt': '已完成',
  'smarthr-ui/Textarea/availableLetters': '還可輸入 {availableLetters} 字',
  'smarthr-ui/Textarea/maxLettersExceeded': '超出 {exceededLetters} 字',
  'smarthr-ui/Textarea/screenReaderMaxLettersDescription': '最多可輸入 {maxLetters} 字',
  'smarthr-ui/OpenInNewTabIcon/openInNewTab': '另開分頁',
  'smarthr-ui/Th/sortDirectionAsc': '遞增',
  'smarthr-ui/Th/sortDirectionDesc': '遞減',
  'smarthr-ui/Th/sortDirectionNone': '無排序',
  'smarthr-ui/ThCheckbox/checkAllInvisibleLabel': '選擇/取消所有項目',
  'smarthr-ui/ThCheckbox/checkColumnName': '選擇',
} as const satisfies Record<keyof typeof ja, string>
